import React from "react";
import { CURRENCY_ICON, CURRENCY_TITLE } from "@app/constants/currencies";
import { Currency } from "@app/types/currencies";

type Props = {
  currency: Currency;
};

export const CurrencyView: React.FC<Props> = ({ currency }) => (
  <div className="flex flex-row items-center gap-2 rounded-none">
    <div className="flex h-6 w-6 overflow-hidden rounded-full">
      {React.createElement(CURRENCY_ICON[currency] ?? null)}
    </div>
    <div className="text-regular">{CURRENCY_TITLE[currency]}</div>
  </div>
);
